import React from 'react';
import {useTranslation} from 'react-i18next';
import {GAME_TYPES} from '../../api';

const DISABLED_MODES = new Set(['compete']);
const HIDDEN_MODES = new Set(['compete']);

export default function GameModeSelector({value, onChange}) {
    const {t} = useTranslation();
    return (
        <div className="GameMode-selector">
            <p className="GameMode-heading">{t('gameMode.chooseLobby')}</p>
            <div className="GameMode-buttons">
                {GAME_TYPES.filter(mode => !HIDDEN_MODES.has(mode.key)).map(mode => {
                    const disabled = DISABLED_MODES.has(mode.key);
                    return (
                        <button
                            key={mode.key}
                            className={'GameMode-btn' + (value === mode.key ? ' active' : '') + (disabled ? ' disabled' : '')}
                            onClick={() => !disabled && onChange(mode.key)}
                            title={disabled ? t('gameMode.comingSoon') : t(mode.descKey)}
                            disabled={disabled}
                        >
                            <span className="GameMode-icon">{mode.icon}</span>
                            <span className="GameMode-label">{t(mode.labelKey)}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
